import gql from 'graphql-tag';

export const mutationCreateSharedPublicLink = gql`
  mutation createSharedPublicLink (
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    createSharedPublicLink (
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
export default mutationCreateSharedPublicLink;
